import React from 'react';
import IndustryOutReachContainer from '../../../Containers/UserContainer/IndustryOutreach';

const IndustryOutReachScreen = () => {
  return <IndustryOutReachContainer />;
};

export default IndustryOutReachScreen;
